import { Resource } from "../resource/resource.model";

/**
 * A role within a tenant. A role is a named bundle of permission keys drawn from
 * the fixed catalog the platform owns (see the roles component's PERMISSION_CATALOG).
 *
 * System roles (admin/config/legal/basic) ship with every tenant and cannot be
 * deleted or renamed. Custom roles are authored by tenant admins.
 *
 * NOTE: the backend collection + endpoints for this model are pending (see
 * docs/superpowers/specs/2026-08-25-rbac-custom-roles-design.md, Phases 1/3).
 */
export class ClientRole extends Resource {
  key: string;
  name: string;
  description: string;
  permissions: string[];
  isSystem: boolean;
  color: number;
}
